// extracted by mini-css-extract-plugin
export default {"flag":"_mmRH0"};